import { Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import * as Highcharts from 'highcharts';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { TableViewService } from '../../table-view.service';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';

@Component({
  selector: 'app-table4',
  templateUrl: './table4.component.html',
  styleUrls: ['./table4.component.scss']
})
export class Table4Component implements OnInit {
  jsonData: any;
  originalData:any;
  data: any;
  //tableData: any;
  tableData: any = {
    rowData: [],
    columnData: [],
    data:[]
  };
  
  headers: any;
  valuesArray: any = {
    data1: [],
    data2: [],
    data3: [],
    data4: [],
    data5: [],
    data6: [],
    data7: [],
    data8: [],
    data9: [],
    data10: []

  };
  usaValues: any;
  properties: any;
  tableTitle: any;
  categories: any[] = [];
  p: number = 1; // Current page
  itemsPerPage: any=10; // Number of items per page
  valuesArray2: any;
  headers1: any[] = [];
  sortcolumn: string | null = null;
  headers2: any;
  start: any;
  end: any;
  cellWidth:number=150;
  cellHeight:number=40;
  rowData: any[] = [];
  columnData: any[] = [];
  columnNestingLevels : any = [2];
  columnNestingData : any [] = [];
  rowNestingData : any [] = [];
  rowDataArr : any  = {"Data":[]};
  colDataArr : any  = {"Data":[]};
  constructor(private http: HttpClient, public tableService: TableViewService,private sanitizer: DomSanitizer,private router: Router,
    private route: ActivatedRoute,private _customSnapshotService: CustomsnapshotService,private _configService: SnapshotService) { }
  @ViewChild('customTable') customTable: ElementRef | undefined;
  @ViewChild('headerElement') headerElement: ElementRef | undefined;
  @ViewChildren('dataCell') dataCells: QueryList<ElementRef> | any;
  
  valuesArrayList: string[][] = [];

  rows: any;

  ngOnInit() {

    this.http.get<any>('assets/Data/rowColNesting.json').subscribe((data: any) => {

      this.jsonData = data;
      this.originalData = JSON.parse(JSON.stringify(data));
      this.properties = data["properties"][0];
      
      this.tableData.data = data;
      this.processData();
    
      //this.headers = Array.from({ length: this.properties.colNumber }, (_, index) => `H${index + 1}`);
      //this.tableTitle = this.tableData[0].title;
      //this.generateRandomData();
    });
  }


  processData(): void {

    this.jsonData.data = this.suppressData();
    const rowDataMap = new Map();
    const columnDataMap = new Map();

    // else{
    // Group data by row and column names
    this.jsonData.data.forEach((item:any) => {
      if (!rowDataMap.has(item.rowName)) {
        rowDataMap.set(item.rowName, new Map());
      }
      if (!columnDataMap.has(item.columnName)) {
        columnDataMap.set(item.columnName, new Map());
      }
      
      const rowMap = rowDataMap.get(item.rowName);
      const columnMap = columnDataMap.get(item.columnName);
      
      if (!rowMap.has(item.rowNesting1)) {
        rowMap.set(item.rowNesting1, []);
      }
      if (!columnMap.has(item.columnNesting1)) {
        columnMap.set(item.columnNesting1, []);
      }
      
      rowMap.get(item.rowNesting1).push(item.rowNesting2);
      columnMap.get(item.columnNesting1).push(item.columnNesting2);
    });

   // Convert row data map to desired format
   this.tableData.rowData = [];
   rowDataMap.forEach((rowNesting1Map, name) => {
    const rowData: { Data: { name: any; children: { name: any; }[]; }[] } = {
      Data: [{
        name: name,
        children: []
      }]
    };
    
    rowNesting1Map.forEach((children:any, nesting1:any) => {
      const uniqueChildren = Array.from(new Set(children)); // Ensuring uniqueness
      const nesting1Data: { name: any; children: { name: any; }[] } = {
        name: nesting1,
        // children: uniqueChildren.map((nesting2: any) => ({ name: nesting2 }))
        children: (uniqueChildren.length > 0 && uniqueChildren[0] != null) ? uniqueChildren.map((nesting2: any) => ({ name: nesting2 })) : []
      };
      rowData.Data[0].children.push(nesting1Data);
    });
  
    this.tableData.rowData.push(rowData);
  });
// Convert column data map to desired format
this.tableData.columnData = [];
columnDataMap.forEach((ColNesting1Map, name) => {
  const columnData: { Data: { name: any; children: { name: any; }[]; }[] } = {
    Data: [{
      name: name,
      children: []
    }]
  };
  ColNesting1Map.forEach((children:any, nesting1:any) => {
    const uniqueChildren = Array.from(new Set(children)); // Ensuring uniqueness
    const nesting1Data: { name: any; children: { name: any; }[] } = {
      name: nesting1,
      // children: uniqueChildren.map((nesting2: any) => ({ name: nesting2 }))
      children: (uniqueChildren.length > 0 && uniqueChildren[0] != null) ? uniqueChildren.map((nesting2: any) => ({ name: nesting2 })) : []
    };
    columnData.Data[0].children.push(nesting1Data);
  });

  this.tableData.columnData.push(columnData);
});
this.rowData = [];
this.columnData = [];
this.rowData = this.tableData.rowData;
      this.columnData = this.tableData.columnData;
      this.columnNestingData = [];
      this.rowNestingData = [];
      if(this.columnData[0].Data[0].children && this.columnData[0].Data[0].children[0].children.length === 0){
        if(this.columnData[0].Data[0].children.length != 0 && this.columnData[0].Data[0].children[0].name != null){
        this.columnNestingData.push(this.columnData[0].Data[0].children);
        }
      }
      if(this.columnData[0].Data[0].children && this.columnData[0].Data[0].children[0].children.length > 0 ){
        this.columnNestingData.push(this.columnData[0].Data[0].children);
        this.columnNestingData.push(this.columnData[0].Data[0].children[0].children);
      }
      if(this.rowData[0].Data[0].children && this.rowData[0].Data[0].children[0].children.length === 0){
        if(this.rowData[0].Data[0].children.length != 0 && this.rowData[0].Data[0].children[0].name != null){
        this.rowNestingData.push(this.rowData[0].Data[0].children);
        }
      }
      if(this.rowData[0].Data[0].children && this.rowData[0].Data[0].children[0].children.length > 0){
         this.rowNestingData.push(this.rowData[0].Data[0].children);
        this.rowNestingData.push(this.rowData[0].Data[0].children[0].children);
      }
      this.rowDataArr = {"Data":[]};
      this.colDataArr = {"Data":[]};
      this.rowData.forEach((x:any)=>{
        this.rowDataArr.Data.push(x.Data[0]);
      })
      this.columnData.forEach((x:any)=>{
        this.colDataArr.Data.push(x.Data[0]);
      })
    // }



    if (this.properties.transpose) {     
      this.rowData = this.tableData.columnData;
       this.columnData = this.tableData.rowData;
       this.columnNestingData = [];
       this.rowNestingData = [];
       if(this.columnData[0].Data[0].children && this.columnData[0].Data[0].children[0].children.length === 0){
        if(this.columnData[0].Data[0].children.length != 0 && this.columnData[0].Data[0].children[0].name != null){
          this.columnNestingData.push(this.columnData[0].Data[0].children);
          }
       }
       if(this.columnData[0].Data[0].children && this.columnData[0].Data[0].children[0].children.length > 0){
         this.columnNestingData.push(this.columnData[0].Data[0].children);
         this.columnNestingData.push(this.columnData[0].Data[0].children[0].children);
       }
       if(this.rowData[0].Data[0].children && this.rowData[0].Data[0].children[0].children.length === 0){
        if(this.rowData[0].Data[0].children.length != 0 && this.rowData[0].Data[0].children[0].name != null){
          this.rowNestingData.push(this.rowData[0].Data[0].children);
        }
       }
       if(this.rowData[0].Data[0].children && this.rowData[0].Data[0].children[0].children.length > 0){
         this.rowNestingData.push(this.rowData[0].Data[0].children);
         this.rowNestingData.push(this.rowData[0].Data[0].children[0].children);
       }
       this.rowDataArr = {"Data":[]};
       this.colDataArr = {"Data":[]};
         this.rowData.forEach((x:any)=>{
         this.rowDataArr.Data.push(x.Data[0]);
       })
       this.columnData.forEach((x:any)=>{
         this.colDataArr.Data.push(x.Data[0]);
       })
     }
  }

  //optimize the code below to remove the nested for loop and use lodash to optimize the code

  onTableDataChange(event: any) {
    this.p = event;
    this.start = (this.p - 1) * this.itemsPerPage;
    this.end = this.start + this.itemsPerPage;


  }
 
  customization() {
    return this.tableService.customizationServiceRowColumnNesting();

  }
  commonFuncNesting(event: any, customization: string, options: any) {
    let property;

    this.tableService.commonFuncNesting(customization, event, this.properties,this.customTable);
    //this.headers = Array.from({ length: this.properties.colNumber }, (_, index) => `H${index + 1}`);
    this.processData();

  }

  
  //To get the count of number of rows along with nesting
  getrowCount(){
    let rowCount=0;
    if(this.tableData!=null && this.tableData!=undefined && this.tableData["rowData"]!=undefined){
        rowCount=rowCount+this.rowDataArr.Data.length;
      if(this.rowNestingData!=undefined){
        this.rowNestingData.forEach((x:any)=>{
          rowCount=rowCount*x.length;
        });
      }
    }
    return rowCount;
  }

  getWidthofCellOnCount2(data:any,type:string){
    let width = data.children[0].children.length == 0 ? data.children.length : data.children.length *  data.children[0].children.length;
    return type === "row" ?this.cellHeight * width:this.cellWidth * width;
  }
  // to get width of the cell based on the 
  getWidthofCellOnCount(panel:string,panelNested:string){
    let rowCellCount=1;
    if(this.tableData!=null && this.tableData!=undefined && this.tableData[panel]!=undefined){
      if(this.tableData[panel][0].Data[0].children !=undefined){
        // this.tableData[panel].forEach((x:any)=>{
        //   rowCellCount=rowCellCount*x.Data[0].children.length;
        // })
        if(panel == 'rowData'){
        this.rowNestingData.forEach((x:any)=>{
          rowCellCount=rowCellCount*x.length;
        });
      }
      else{
        this.columnNestingData.forEach((x:any)=>{
          rowCellCount=rowCellCount*x.length;
        })
      }
      }
    }
    let heightWidth=(panel=='rowData')?this.cellHeight:this.cellWidth;
    return rowCellCount*heightWidth;
  }

  getNestingCount(index:number,panel:string,panelNested:string){
    let rowCellCount=1;
    if(this.tableData!=null && this.tableData!=undefined && this.tableData[panel]!=undefined){
      if(this.properties.transpose){
        if(panel == "rowData"){
        if(this.tableData["columnData"][0].Data[0].children !=undefined){
          for(let i=0;i<=index;i++){
            if(this.tableData[panel].length === 1){
              rowCellCount=rowCellCount*this.tableData["columnData"][0].Data[0].children.length;
            }
            else{
            rowCellCount=rowCellCount*this.tableData["columnData"][i].Data[0].children.length;
            }
          }
        }
        }
        else if(panel == "columnData"){
          if(this.tableData["rowData"][0].Data[0].children !=undefined){
            for(let i=0;i<=index;i++){
              if(this.tableData[panel].length === 1){
                rowCellCount=rowCellCount*this.tableData["rowData"][0].Data[0].children.length;
              }
              else{
              rowCellCount=rowCellCount*this.tableData["rowData"][i].Data[0].children.length;
              }
            }
          }
        }
      }
      else{
      if(this.tableData[panel][0].Data[0].children !=undefined){
      //   if(this.tableData[panel][0].Data[0].children[0].children != undefined){
      //     for(let i=0;i<=index;i++){
      //       rowCellCount=rowCellCount*(this.tableData[panel][i].Data[0].children.length + this.tableData[panel][i].Data[0].children[i].children.length);
      //     }
      //   }
      //   else{
      //   for(let i=0;i<=index;i++){
      //     rowCellCount=rowCellCount*this.tableData[panel][i].Data[0].children.length;
      //   }
      // }
      for(let i=0;i<=index;i++){
        if(this.tableData[panel].length === 1){
          rowCellCount=rowCellCount*this.tableData[panel][0].Data[0].children.length;
        }
        else{
        rowCellCount=rowCellCount*this.tableData[panel][i].Data[0].children.length;
        }
      }
      }
      }
    }
    return this.getWidthofCellOnCount(panel,panelNested)/rowCellCount;
  }

  //get the column and column nested count
  getrowCellCount(){
    let rowCellCount=0;
    if(this.tableData!=null && this.tableData!=undefined && this.tableData["columnData"]!=undefined){
        rowCellCount=rowCellCount+this.colDataArr.Data.length;
      if(this.columnNestingData!=undefined){
        this.columnNestingData.forEach((x:any)=>{
          rowCellCount=rowCellCount*x.length;
        })
      }
    }
    return rowCellCount;
  }

  //get the count for row or column nesting count
  getNestedLevelCount(index:number,nesting:any){
    let count=1;
    for(let i=0;i<index;i++){
      if(nesting[i].Data[0].children){
      count=count*nesting[i].Data[0].children.length;
      }
    }
    return count;
  }

  getNestedLevelCountLevel3(index:number,nesting:any){
    let count=1;
    for(let i=0;i<index;i++){
      if(nesting[i].Data[0].children[0].children){
        count=count*nesting[i].Data[0].children[i].children.length;
      }
    }
    return count;
  }
  
  // Margin for the scroll based on the count of nested rows and columns
  getMarginForScroll(){
    let colRowCount=0;
    let RowColCount=0;
    if(this.tableData!=null && this.tableData!=undefined){
      if(this.tableData["columnData"]!=undefined && this.tableData["columnData"].length>0)
        colRowCount=1;
      if(this.columnNestingData!=undefined && this.columnNestingData.length>0)
        colRowCount=colRowCount+this.columnNestingData.length;
      if(this.tableData["rowData"]!=undefined && this.tableData["rowData"].length>0)
        RowColCount=1;
      if(this.rowNestingData!=undefined && this.rowNestingData.length>0)
        RowColCount=RowColCount+this.rowNestingData.length;
    }
    return `${(25 * colRowCount)}px 0 0 ${(150 * RowColCount)}px`
  }

  getValue(row:any,column:any,rowNesting:any,colNesting:any){
     let val = undefined;
     this.tableData.data.data.forEach((element:any) => {
      // Check if the element matches the provided parameters
      if(this.properties.transpose){
        if (element.rowName === column && element.columnName === row && element.rowNesting1 === colNesting && element.columnNesting1 === rowNesting) {
          // If the element matches, set val to the value property
          val = this.getDataLabel(element);
        }
      }
      else{
      if (element.rowName === row && element.columnName === column && element.rowNesting1 === rowNesting && element.columnNesting1 === colNesting) {
        // If the element matches, set val to the value property
        val = this.getDataLabel(element);
      }
      }
     });
     return val;
  }

  getValueLevel2ColRowNesting(row:any,column:any,rowNesting:any,colNesting:any,rowNesting2:any,colNesting2:any){
    let val = undefined;
    let found = false; // Flag to indicate if val is found
    this.tableData.data.data.forEach((element:any) => {
        // Check if the element matches the provided parameters
        if (!found && this.properties.transpose){
            if (element.rowName === column && element.columnName === row && element.rowNesting1 === colNesting && element.columnNesting1 === rowNesting && element.rowNesting2 === colNesting2 && element.columnNesting2 === rowNesting2) {
                // If the element matches, set val to the value property
                val = this.getDataLabel(element);
                found = true; // Set found to true to break the loop
            }
        }
        else if (!found){
            if (element.rowName === row && element.columnName === column && element.rowNesting1 === rowNesting && element.columnNesting1 === colNesting && element.rowNesting2 === rowNesting2 && element.columnNesting2 === colNesting2) {
                // If the element matches, set val to the value property
                val = this.getDataLabel(element);
                found = true; // Set found to true to break the loop
            }
        }
    });
    return val;
 }

 getValueLevel2RowNesting(row:any,column:any,rowNesting:any,colNesting:any,rowNesting2:any){
  let val = undefined;
  let found = false; // Flag to indicate if val is found
  this.tableData.data.data.forEach((element:any) => {
   // Check if the element matches the provided parameters
   if( !found && this.properties.transpose){
     if (element.rowName === column && element.columnName === row && element.rowNesting1 === colNesting && element.columnNesting1 === rowNesting && element.rowNesting2 === rowNesting2) {
       // If the element matches, set val to the value property
       val = this.getDataLabel(element);
       found = true; // Set found to true to break the loop
     }
   }
   else if (!found){
   if (element.rowName === row && element.columnName === column && element.rowNesting1 === rowNesting && element.columnNesting1 === colNesting && element.rowNesting2 === rowNesting2) {
     // If the element matches, set val to the value property
     val = this.getDataLabel(element);
     found = true; // Set found to true to break the loop
   }
   }
  });
  return val;
}

getDataLabel(element:any){
  let label = "";
  if(this.properties.datalabelStyle == "default"){
    let val = element.value != null ? (this.properties.datalabelFormat == "number" ? element.value : element.value + "%"):"NA" ; 
    let dataLabelColor = this.properties.dataLabelColor !== undefined ? this.properties.dataLabelColor : '';
    label = `<span class="val-data" style="color: ${dataLabelColor};font-size:${this.properties.dataLabelSize} ! important">${val}</span>`;
  }
  else if(this.properties.datalabelStyle == "datalabel"){
    let val = element.value != null ? (this.properties.datalabelFormat == "number" ? element.value : element.value + "%"):"NA" ; 
    let dataLabelColor = this.properties.dataLabelColor !== undefined ? this.properties.dataLabelColor : '';
    label = `<span class="val-data" style="color: ${dataLabelColor} ;font-size:${this.properties.dataLabelSize} ! important">${val}</span>`;
  }
  else if (this.properties.datalabelStyle == "change") {
    let val = element.value != null ? (this.properties.datalabelFormat == "number" ? element.value : element.value + "%"):"NA" ; 
    let dataLabelColor = this.properties.dataLabelColor !== undefined ? this.properties.dataLabelColor : '';
    let changeText = element.ChangeVs;
    if (parseFloat(changeText) > 0) {
      changeText = "(" + "+" + changeText+")";
    }
    else if(parseFloat(changeText) < 0){
      changeText = "(" + changeText+ ")";
    }
    label = `<span class="val-data" style="color: ${dataLabelColor}; font-size:${this.properties.dataLabelSize} ! important">${val} <span class="change-data" style="color:black;">${changeText}</span></span>`;
  }
  else if (this.properties.datalabelStyle == "significance") {
    let val = element.value != null ? (this.properties.datalabelFormat == "number" ? element.value : element.value + "%"):"NA" ; 
    let dataLabelColor = this.properties.dataLabelColor !== undefined ? this.properties.dataLabelColor : '';
    let sig = element.Significance;
    let s = sig > 0 ? this.tableService.upwardTriangle : (sig < 0 ? this.tableService.downwardTriangle : '');
    let sigcolor = sig > 0 ? this.tableService.highSignificance : (sig < 0 ? this.tableService.lowSignificance : '');
    let finalText = '<span class="val-data" style="color: '+dataLabelColor+';font-size:'+this.properties.dataLabelSize +' ! important">' + val + ( element.value != null ? '&nbsp<span class="significance" style="color:' + sigcolor + '! important ;">' + s + '</span>' : '') + '</span>' ;
    label = finalText;

  }
  else if (this.properties.datalabelStyle == "significance + changeVs") {
    let val = element.value != null ? (this.properties.datalabelFormat == "number" ? element.value : element.value + "%"):"NA" ; 
    let dataLabelColor = this.properties.dataLabelColor !== undefined ? this.properties.dataLabelColor : '';
    //extract each changeVs value
    let changeText = element.ChangeVs;
    //extarct each signififcance value
    let sig = element.Significance;
    //set the significance arrow according to its value
    let s = sig > 0 ? this.tableService.upwardTriangle : (sig < 0 ? this.tableService.downwardTriangle : '');
    //assign color to the arrow
    let sigcolor = sig > 0 ? this.tableService.highSignificance : (sig < 0 ? this.tableService.lowSignificance : '');
    //include + if changeValue is positive
    if (parseFloat(changeText) > 0) {
      changeText = "+" + changeText;
    }
    else if(parseFloat(changeText) < 0){
      changeText =  changeText;
    }
    //merge text+changeText+significance 
    let finalText = '<span>' +
      '<span class="val-data" style="color:  '+dataLabelColor+';font-size:'+this.properties.dataLabelSize +' ! important">' + val + '</span>' +
      (element.value != null && changeText ? '<span>&nbsp' +
      '<span class="change-data" style="font-size: ' + this.tableService.changeValueFontSize + ';color:' + (this.properties.darkTheme ? this.tableService.darkThemeTextColor : this.tableService.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
        '<span class="significance" style="color:' + sigcolor + ';">' + s + '</span>' : '') +
      '</span>';
      label = finalText;


  }
  else if (this.properties.datalabelStyle == "ls") {

    let dataLabelColor = this.properties.dataLabelColor !== undefined ? this.properties.dataLabelColor : '';
    let text = parseFloat(element.SampleSize) > this.tableService.sampleSizeConstant ?element.value != null ? (this.properties.datalabelFormat == "number" ? element.value : element.value + "%"):"NA" : this.tableService.lowSampleText;
    let finalText = '<span style="color:  '+dataLabelColor+';font-size:'+this.properties.dataLabelSize +' ! important">' +
      text +
      '</span> ' +
      '<span style="opacity: 0.5"></span>';

      label= finalText;
  }
  else if (this.properties.datalabelStyle == "significance2") {
    let text = element.value != null ? (this.properties.datalabelFormat == "number" ? element.value : element.value + "%"):"NA" ; 
    let changeText = element.ChangeVs;
    let sig = element.Significance;
    let sig1 = element.Significance2;
    let sColor = sig > 0 ? this.tableService.highSignificance : (sig < 0 ? this.tableService.lowSignificance : '');
    let s = sig > 0 ? this.tableService.upwardTriangle : (sig < 0 ? this.tableService.downwardTriangle : '');
    let changeColor = sig1 < 0 ? this.tableService.lowSignificance : (sig1 > 0 ? this.tableService.highSignificance : this.properties.darkTheme ? this.tableService.darkThemeTextColor : this.tableService.defaultThemeTextColor);
    let dataLabelColor = this.properties.dataLabelColor !== undefined ? this.properties.dataLabelColor : '';
    if (parseFloat(changeText) > 0) {
      changeText = "+" + changeText;
    }
    else if(parseFloat(changeText) < 0){
      changeText =  changeText;
    }
    let finalText = '<span style="color:  '+dataLabelColor+';font-size:'+this.properties.dataLabelSize +' ! important">' + text +
      (element.value != null && changeText ? '&nbsp<span style="color:' + (this.properties.darkTheme ? this.tableService.darkThemeTextColor : this.tableService.defaultThemeTextColor) + ' "> ' +
        '<span style="font-size:' + this.tableService.changeValueFontSize + '; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
        '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
      '</span>';
    label = finalText;
  }

   return this.sanitizer.bypassSecurityTrustHtml(label);
}

  getValueWithoutNesting(row:any,column:any){
    let val = undefined;
    let found = false; // Flag to indicate if val is found
    this.tableData.data.data.forEach((element:any) => {
     // Check if the element matches the provided parameters
     if( !found && this.properties.transpose){
      if (element.rowName === column && element.columnName === row) {
        // If the element matches, set val to the value property
        val = this.getDataLabel(element);
        found = true; // Set found to true to break the loop
      }
     }
     else if(!found){
     if (element.rowName === row && element.columnName === column) {
       // If the element matches, set val to the value property
       val = this.getDataLabel(element);
       found = true; // Set found to true to break the loop
     }
    }
    });
    return val;
 }
  getValueColumnNestingOnly(row:any,column:any,colNesting:any,colNesting2:any){
    let val = undefined;
    let found = false; // Flag to indicate if val is found
    this.tableData.data.data.forEach((element:any) => {
     // Check if the element matches the provided parameters
     if( !found && this.properties.transpose){
      if (element.rowName === column && element.columnName === row && element.columnNesting1 === colNesting && element.columnNesting2 === colNesting2) {
        // If the element matches, set val to the value property
        val = this.getDataLabel(element);
        found = true; // Set found to true to break the loop
      }
     }
     else if(!found){
     if (element.rowName === row && element.columnName === column && element.columnNesting1 === colNesting && element.columnNesting2 === colNesting2) {
       // If the element matches, set val to the value property
       val = this.getDataLabel(element);
       found = true; // Set found to true to break the loop
     }
    }
    });
    return val;
 }
 getValueRowNestingOnly(row:any,column:any,rowNesting:any,rowNesting2:any){
  let val = undefined;
  let found = false; // Flag to indicate if val is found
  this.tableData.data.data.forEach((element:any) => {
   // Check if the element matches the provided parameters
   if( !found && this.properties.transpose){
    if (element.rowName === column && element.columnName === row && element.rowNesting1 === rowNesting && element.rowNesting2 === rowNesting2) {
      // If the element matches, set val to the value property
      val = this.getDataLabel(element);
      found = true; // Set found to true to break the loop
    }
   }
   else if(!found){
   if (element.rowName === row && element.columnName === column && element.rowNesting1 === rowNesting && element.rowNesting2 === rowNesting2) {
     // If the element matches, set val to the value property
     val = this.getDataLabel(element);
     found = true; // Set found to true to break the loop
   }
  }
  });
  return val;
}

getValueColumnNestingWithoutRowNesting(row:any,column:any,colNesting:any){
  let val = undefined;
  let found = false; // Flag to indicate if val is found
  this.tableData.data.data.forEach((element:any) => {
   // Check if the element matches the provided parameters
   if( !found && this.properties.transpose){
    if (element.rowName === column && element.columnName === row && element.rowNesting1 === colNesting) {
      // If the element matches, set val to the value property
      val = this.getDataLabel(element);
      found = true; // Set found to true to break the loop
    }
   }
   else if(!found){
   if (element.rowName === row && element.columnName === column && element.colNesting1 === colNesting) {
     // If the element matches, set val to the value property
     val = this.getDataLabel(element);
     found = true; // Set found to true to break the loop
   }
  }
  });
  return val;
}

suppressData(){
  let supressesData = JSON.parse(JSON.stringify(this.originalData.data));
  const rowName = this.properties.transpose ? "columnName" : "rowName";
  const rowNesting1 = this.properties.transpose ? "columnNesting1" : "rowNesting1";
  const rowNesting2 = this.properties.transpose ? "columnNesting2" : "rowNesting2";
  const columnName = this.properties.transpose ? "rowName" : "columnName";
  const columnNesting1 = this.properties.transpose ? "rowNesting1" : "columnNesting1";
  const columnNesting2 = this.properties.transpose ? "rowNesting2" : "columnNesting2";
  supressesData.filter((d: any) => d.rowNesting1 == "Row 1 Child 1").forEach((element: any) => {
    element.value = null;
  });
  supressesData.filter((d: any) => d.columnNesting1 == "Column 1 Child 1").forEach((element: any) => {
    element.value = null;
  });
  if (this.properties.suprressColumn) {
    let tempData: any[] = [];
    const uniqueColumn = this.unique(supressesData, [columnName, columnNesting1, columnNesting2]);
    uniqueColumn.forEach((ele: any) => {
      let uniqueData = supressesData.filter((d: any) => (
        d[columnName] == ele[columnName]
        && d[columnNesting1] == ele[columnNesting1]
        && d[columnNesting2] == ele[columnNesting2]
      ));
      if (uniqueData.filter((d: any) => d.value != null).length > 0) {
        tempData.push.apply(tempData, uniqueData)
      }
    });
    supressesData = tempData;
  }
  if (this.properties.suppressRow) {
    let tempData: any[] = [];
    const uniqueRow = this.unique(supressesData, [rowName, rowNesting1, rowNesting2]);
    uniqueRow.forEach((ele: any) => {
      let uniqueData = supressesData.filter((d: any) => (
        d[rowName] == ele[rowName]
        && d[rowNesting1] == ele[rowNesting1]
        && d[rowNesting2] == ele[rowNesting2]
      ));
      if (uniqueData.filter((d: any) => d.value != null).length > 0) {
        tempData.push.apply(tempData, uniqueData)
      }
    });
    supressesData = tempData;
  }
  return supressesData;
}
unique(arr:any[], keyProps:any) {
  return Object.values(arr.reduce((uniqueMap, entry) => {
    const key = keyProps.map((k:any) => entry[k]).join('|');
    if (!(key in uniqueMap)) uniqueMap[key] = entry;
    return uniqueMap;
  }, {}));
}

}
